// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3422f752","453":"af8deb64","732":"c3fca80d","977":"ae163c07"}[chunkId] + ".chunk.js";
};